<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>代征平台定期维护(季度)</span>
    </div>
    <!-- end of title -->

    <el-form :model="formData" :rules="formRules" ref="formData" label-width="200px">
      <!-- start of 基础信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 合同名称 -->
              <el-form-item label="合同名称" prop="contractGuid">
                <el-select clearable size="small" :disabled="guid ? true: false" filterable v-model="formData.contractGuid" placeholder="请选择" @change="changeContractList">
                  <el-option
                    v-for="(item, index) in contractList"
                    :key="item.guid + index"
                    :label="item.contractName"
                    :value="item.guid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <!-- 签约企业 -->
              <el-form-item label="签约企业" prop="tenantNameA">
                <el-input placeholder="请填写" disabled size="small" type="text" v-model="formData.tenantNameA"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" prop="tenantName">
                <el-input placeholder="请填写" disabled size="small" type="text" v-model="formData.tenantName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 业务联系人 -->
              <el-form-item label="业务联系人" prop="contacts">
                <el-input :maxlength="10" placeholder="请填写" disabled size="small" type="text" v-model="formData.contacts"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <!-- 联系电话 -->
              <el-form-item label="联系电话" prop="contactTel">
                <el-input type="number" disabled oninput="if(value.length>11)value=value.slice(0, 11)" placeholder="请输入" :maxlength="11" size="small" v-model="formData.contactTel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 维护时间 -->
              <el-form-item label="维护时间" prop="expireDate">
                <el-date-picker disabled size="small" placeholder="请选择" value-format="yyyy-MM-dd" v-model="formData.expireDate"></el-date-picker>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <!-- 月度合作上限调整(元) -->
              <el-form-item label="月度合作上限调整(元)" prop="monthMaxMoney">
                <el-input
                  @blur="formData.monthMaxMoney = Number($event.target.value)"
                  oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)"
                  :maxlength="12"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.monthMaxMoney"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <!-- 是否继续合作 -->
              <el-form-item label="是否继续合作" prop="isContinueCooperation">
                <el-radio-group v-model="formData.isContinueCooperation">
                  <el-radio label='Y'>是</el-radio>
                  <el-radio label='N'>否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 基础信息 -->
    </el-form>

    <el-form :model="formOthetData" ref="formOthetData" label-width="200px">
      <!-- start of 维护信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">维护信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12" v-for="(item, index) in checkItems" :key="item.itemKey">
              <el-form-item
                :label="item.itemName"
                :prop="item.itemKey"
                :rules="[
                  { required: true, message: item.itemName + '必填', trigger: 'change' }
                ]"
              >
                <el-radio-group v-model="formOthetData[item.itemKey]">
                  <!-- 服务响应效率、发票时效性 -->
                  <template v-if="item.itemKey === 'fwxyxl' || item.itemKey === 'fpsxx'">
                    <el-radio label='Y'>及时</el-radio>
                    <el-radio label='N'>不及时</el-radio>
                  </template>
                  <!-- 需求响应度、系统操作性 -->
                  <template v-else-if="item.itemKey === 'xqxyd' || item.itemKey === 'xtczx'">
                    <el-radio label='Y'>很好</el-radio>
                    <el-radio label='P'>一般</el-radio>
                    <el-radio label='N'>不好</el-radio>
                  </template>
                  <!-- 先票后款 -->
                  <template v-else-if="item.itemKey === 'xphk'">
                    <el-radio label='Y'>接受</el-radio>
                    <el-radio label='N'>不接受</el-radio>
                  </template>
                  <!-- 提供完税凭证 -->
                  <template v-else-if="item.itemKey === 'tgwspz'">
                    <el-radio label='Y'>可以</el-radio>
                    <el-radio label='N'>不可以</el-radio>
                  </template>
                  <template v-else>
                    <el-radio label='Y'>是</el-radio>
                    <el-radio label='N'>否</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="bottom-btn-box">
          <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
        </div>
      </div>
      <!-- end of 维护信息 -->
    </el-form>
  </div>
</template>

<script>

export default {
  data() {
    return {
      guid: '',
      // 表单字段
      formData: {
        contractGuid: '', // 合同名称
        tenantGuid: '', // 企业名称
        tenantName: '', // 企业名称
        contacts: '', // 业务联系人
        contactTel: '', // 联系电话
        expireDate: new Date(), // 维护时间
        isContinueCooperation: '', // 是否继续合作
        monthMaxMoney: 3000000, // 月度合作上限调整
      },
      // 表单验证规则
      formRules: {
        contractGuid: [
          { required: true, message: '合同名称必填', trigger: 'change' }
        ],
        tenantGuid: [
          { required: true, message: '企业名称必填', trigger: 'change' }
        ],
        contacts: [
          { required: true, message: '业务联系人必填', trigger: 'change' }
        ],
        contactTel: [
          { required: true, message: '联系电话必填', trigger: 'change' }
        ],
        expireDate: [
          { required: true, message: '维护时间必填', trigger: 'change' }
        ],
        isContinueCooperation: [
          { required: true, message: '是否继续合作必填', trigger: 'change' }
        ],
        monthMaxMoney: [
          { required: true, message: '月度合作上限调整必填', trigger: 'blur' }
        ]
      },
      contractList: [], // 合同下拉选数据
      formOthetData: {},
      // 表单 维护信息 数据
      checkItems: [{
        "itemName": "公司是否新增风险案例",
        "itemKey": "gssfxzfxal",
        "itemValue": ""
      },{
        "itemName": "服务响应效率",
        "itemKey": "fwxyxl",
        "itemValue": ""
      },{
        "itemName": "与地方政府关系是否有变化",
        "itemKey": "ydfzfgxsfybh",
        "itemValue": ""
      },{
        "itemName": "需求响应度",
        "itemKey": "xqxyd",
        "itemValue": ""
      },{
        "itemName": "公司高层是否发生变化",
        "itemKey": "gsgcsffsbh",
        "itemValue": ""
      },{
        "itemName": "发票时效性",
        "itemKey": "fpsxx",
        "itemValue": ""
      },{
        "itemName": "与传世是否开通共管账户",
        "itemKey": "ycssfktggzh",
        "itemValue": ""
      },{
        "itemName": "先票后款",
        "itemKey": "xphk",
        "itemValue": ""
      },{
        "itemName": "当地政策是否发生变化",
        "itemKey": "ddzcsffsbh",
        "itemValue": ""
      },{
        "itemName": "系统操作性",
        "itemKey": "xtczx",
        "itemValue": ""
      },{
        "itemName": "公司人数是否发生变化",
        "itemKey": "gsrssffsbh",
        "itemValue": ""
      },{
        "itemName": "提供完税凭证",
        "itemKey": "tgwspz",
        "itemValue": ""
      },{
        "itemName": "是否增加了医药客户资源",
        "itemKey": "sfzjlyykhzy",
        "itemValue": ""
      },{
        "itemName": "是否无感电签",
        "itemKey": "sfwgdq",
        "itemValue": ""
      }],

      // 企业下拉选数据
      tenantList: [],
    };
  },
  created() {
    // this.getTenantData();
    this.getContractData()
    // 修改时需要获取详情数据，给表单赋值
    if(this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      // 基本信息
      let form = JSON.parse(this.$route.params.form);
      // console.log(form)
      this.formData['guid'] = form['guid'];
      this.formData['tenantGuidA'] =  form['tenantGuidA']; // 签约企业名称
      this.formData['tenantNameA'] =  form['tenantNameA']; // 签约企业名称
      this.formData['contractGuid'] = form['contractGuid'];
      this.formData['contractName'] = form['contractName'];
      this.formData['tenantGuid'] = form['tenantGuid'];
      this.formData['tenantName'] = form['tenantName'];
      this.formData['contacts'] = form['contacts'];// 业务联系人
      this.formData['contactTel'] = form['contactTel']; // 联系电话
      this.formData['expireDate'] = form['inputTime']; // 维护时间
      this.formData['isContinueCooperation'] = form['isContinueCooperation']; // 是否继续合作
      this.formData['monthMaxMoney'] = form['monthMaxMoney']; // 月度合作上限调整
      // 维护信息
      this.getDetailData(this.guid);
    }
  },
  watch: {},
  methods: {
    /**
     * 获取代征平台首次维护数据中所有的合同信息
     */
    getContractData() {
      let that = this;
      that.api.get(
        `/${serverConfig.msCustomerService}/levyEnterpriseCredential/getAllContract` ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // console.log(res.data)
          this.contractList =  res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 修改合同的时候，重新给表单的其他信息赋值
     */
     changeContractList(val) {
      console.log(val)
      let list = this.contractList.filter(item => {
        return item.guid == val
      })
      let datas = list[0];
      this.formData['contractGuid'] = datas['guid']; // 合同名称
      this.formData['contracName'] = datas['contracName']; // 合同名称
      this.formData['tenantGuidA'] = datas['tenantGuid']; // 签约企业guid
      this.formData['tenantNameA'] = datas['tenantName']; // 签约企业名称
      
      this.getTenantDetail(datas['serviceTenantGuid']);
      // console.log(list)
      console.log(this.formData)
     },
    /**
     * 获取企业数据
     */
     getTenantData() {
      let that = this;
      that.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          // "enterpriseCate": '9904',
          'enterpriseCates': ['9903', '9904'],
          "pageIndex": 1,
          "pageSize": -1
        }
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data)
          this.tenantList = (res.data.data && res.data.data.records) ? res.data.data.records : [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 更改企业id的时候，需要将已有的数据带出来
     * @param {*} guid 
     */
    changeTenant(guid) {
      this.getTenantDetail(guid);
    },
    /**
     * 获取企业基本信息
     */
     getTenantDetail(guid) {
      let that = this;
      let formData = {};
      that.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=` + guid,
      ).then((resp) => {
        const { data } = resp;
        if(data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || that.formData;

          formData['contractGuid'] =  that.formData['contractGuid']; // 合同名称
          formData['contracName'] =  that.formData['contracName']; // 合同名称
          formData['tenantGuidA'] =  that.formData['tenantGuidA']; // 签约企业名称
          formData['tenantNameA'] =  that.formData['tenantNameA']; // 签约企业名称

          formData['tenantGuid'] = datas['guid'];
          formData['tenantName'] = datas['tenantName'];
          formData['contacts'] = datas['contacts'];// 业务联系人
          formData['contactTel'] = datas['contactTel']; // 联系电话
          formData['expireDate'] = new Date(); // 维护时间
          formData['monthMaxMoney'] = 3000000; // 月度合作上限调整
          formData['isContinueCooperation'] = ''; // 是否继续合作
          
          that.$set(that, 'formData', formData);
        }
      });
    },
    /**
     * 获取表单数据
     */
    getDetailData(guid) {
      let that = this;
      that.api.get(
        `/${serverConfig.msCustomerService}/tenant-check/levy-check/detail?guid=` + guid,
      ).then((resp) => {
        const { data } = resp;
        if(data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let chkItem = data.data || that.checkItems;
          that.checkItems = chkItem;
          // 维护信息，表单赋值
          let otherData = {};
          chkItem.forEach((item, index) => {
            otherData[item['itemKey']] = item['itemValue'];
          })
          that.formOthetData = otherData;
        }
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      let { formData, checkItems, formOthetData } = this;
      let that = this;
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          that.$refs['formOthetData'].validate((oValid) => {
            if (oValid) {
              let postUrl = `/${serverConfig.msCustomerService}/tenant-check/levy-check/add`;
              // 编辑接口
              if(that.guid) {
                postUrl = `/${serverConfig.msCustomerService}/tenant-check/levy-check/update`;
              }
              
              for(let i in formOthetData) {
                checkItems.forEach((item, index) => {
                  if(i == item['itemKey']) {
                    item['itemValue'] = formOthetData[i];
                    // 新增的时候需要将每条信息添加排序和tenantGuid
                    if(!that.guid) {
                      item['itemIndex'] = index + 1; // 排序
                      item['tenantGuid'] = formData['tenantGuid'];
                      item['contractGuid'] = formData['contractGuid'];
                    }
                  }
                })
              }

              const postData = {
                ...formData,
                checkItems
              };
              that.api.postJson(
                postUrl,
                postData
              ).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  that.$message.success('保存成功');
                  that.$router.go(-1);// 返回上一页
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              console.log('error submit -2 !!');
              return false;
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script> 
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  .title-box {
    border-top: 1px solid #E5E5E5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217,217,217,1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
    }
    
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 8px;
    }
    .el-input, .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px ;
      text-align: center;
      border-top: 1px solid #E5E5E5;
    }
  }
  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }
}
</style>